module.exports = __webpack_public_path__ + "static/img/mica-4.2e62d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/mica-4.jpg
// module id = sufA
// module chunks = 1